/**
 * Reports Store
 * Zustand store for managing reports state
 */

import { create } from 'zustand';
import { fetchQuestionsReport as fetchQuestionsReportAPI } from '../services/reports.service';
import type { ReportsStore } from '../interfaces/storeInterfaces/reportsStore';

export const useReportsStore = create<ReportsStore>((set) => ({
  questions: [],
  pagination: null,
  isLoading: false,
  error: null,

  fetchQuestionsReport: async (params) => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetchQuestionsReportAPI(params);
      
      console.log('=== Reports API Response ===');
      console.log('Full Response:', response);
      console.log('Data (Questions):', response.data);
      console.log('Pagination:', response.pagination);
      console.log('Total Questions:', response.data.length);
      console.log('============================');
      
      set({
        questions: response.data,
        pagination: response.pagination,
        isLoading: false,
      });
    } catch (error) {
      console.error('=== Reports API Error ===');
      console.error('Error:', error);
      console.error('=========================');
      set({
        questions: [],
        pagination: null,
        error: error instanceof Error ? error.message : 'Failed to fetch questions report',
        isLoading: false,
      });
    }
  },

  reset: () => {
    set({
      questions: [],
      pagination: null,
      isLoading: false,
      error: null,
    });
  },
}));
